<template>
  <ul class="pagination-wrap">
    <li @click="prevPaging">
      <div class="pagi-btn">
        <img src="@/assets/imgs/common/pagi-prev.svg" alt="이전" />
      </div>
    </li>

    <li
      v-for="item in page_range"
      :key="'paging' + item"
      class="num"
      :class="page_number === item ? 'on' : ''"
      @click="
        page_number = item;
        movePaging();
      "
    >
      {{ item }}
    </li>
    <li @click="nextPaging">
      <div class="pagi-btn">
        <img src="@/assets/imgs/common/pagi-next.svg" alt="다음" />
      </div>
    </li>
  </ul>
</template>

<script>
import { ref } from "@vue/reactivity";
import { onMounted, watch } from "@vue/runtime-core";
export default {
  props: {
    //전체 데이터
    totaldata: {
      type: Number,
      required: true,
      default: 1,
    },
    //보여주고 싶은 데이터 개수
    pagingdata: {
      type: Number,
      required: true,
      default: 50,
    },
    //보여주고 싶은 페이징 단위
    pagingrange: {
      type: Number,
      required: true,
      default: 5,
    },
    //페이징 정렬(중앙,왼쪽,오른쪽)
    alignment: {
      type: String,
      required: false,
      default: "center",
    },
    //페이지세팅
    setPage: {
      type: Number,
      required: false,
      default: 1,
    },
  },
  emits: ["onPaging"],

  setup(props, context) {
    const page_number = ref(1);
    const totalpaging = ref(Math.ceil(props.totaldata / props.pagingdata));
    const page_range = ref([]);

    const prevPaging = () => {
      if (page_number.value === 1) {
        alert(`첫번째 페이지 입니다.`);
        return;
      }

      page_number.value--;

      if ((page_number.value - 1) % props.pagingrange === 0) {
        page_range.value = prevRange();
      }

      movePaging();
    };

    const nextPaging = () => {
      if (totalpaging.value <= page_number.value) {
        alert(`마지막 페이지 입니다.`);
        return;
      }

      page_number.value++;

      if (page_number.value % props.pagingrange === 1) {
        page_range.value = nextRange();
      }

      movePaging();
    };

    const movePaging = () => {
      context.emit("onPaging", page_number.value);
    };

    const nextRange = () => {
      const newRange = Array.from(
        new Array(props.pagingrange),
        (_, i) => page_number.value + i
      );
      return newRange.filter((item) => item <= totalpaging.value);
    };

    const prevRange = () => {
  const currentPage = page_number.value;
  const totalPages = Math.ceil(props.totaldata / props.pagingdata);
  const rangeStart = Math.max(currentPage - props.pagingrange, 1);
  let rangeEnd = currentPage - 1;

  if (rangeEnd < 1) {
    rangeEnd = Math.min(totalPages, props.pagingrange);
  }

  const newRange = [];
  for (let i = rangeStart; i <= rangeEnd; i++) {
    newRange.push(i);
  }

  return newRange;
};

    onMounted(async () => {
      setTimeout(() => {
        page_number.value = props.setPage;
        totalpaging.value = Math.ceil(props.totaldata / props.pagingdata);
        page_range.value = nextRange();
      }, 100);
    });

    return {
      page_number,
      totalpaging,
      page_range,
      prevPaging,
      nextPaging,
      movePaging,
      nextRange,
      prevRange,
    };
  },
};
</script>

<style lang="scss" scoped>
.pagination-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0 33px;

  li {
    font-size: 13px;
    cursor: pointer;

    &.num {
      padding-bottom: 5px;
      height: 23px;
      border-bottom: 1px solid transparent;
    }

    &.on {
      border-bottom: 1px solid $black;
    }

    .pagi-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 30px;
      border: 1px solid #676767;
      border-radius: 6px;
    }
  }
}
</style>
